"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var TopicFeaturedImage = function TopicFeaturedImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt;
  return (0, _preact.h)("div", {
    className: "box__pad--sides--large-only"
  }, (0, _preact.h)("img", {
    className: "thread-details-featured-image qa-thread-featured-image",
    "data-qa": "thread-featured-image",
    srcSet: "".concat(src, " 480w,").concat(src, " 700w,").concat(src, " 1000w,").concat(src, " 1400w,").concat(src, " 2000w"),
    sizes: "(max-width: 1024px) 700px, 100vw",
    src: (0, _absoluteUrlRuntime.resolveUrl)(src),
    alt: alt
  }));
};

var _default = TopicFeaturedImage;
exports.default = _default;